/*
 * GSTR9New Common Constants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'gstr9new/Common' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'gstr9new/Common/YOUR_ACTION_CONSTANT';
 */

// Common loader actions
export const LOADER_STATUS = 'gstr9new/Common/LOADER_STATUS';

// Common profile and authentication
export const PROFILE_INFO = 'gstr9new/Common/PROFILE_INFO';

// Common notification actions
export const ON_NOTIFY = 'gstr9new/Common/ON_NOTIFY';
export const RESPONSE_MESSAGE = 'gstr9new/Common/RESPONSE_MESSAGE';

// Common table data actions
export const SET_TABLE_DATA = 'gstr9new/Common/SET_TABLE_DATA';
export const TOTAL_RECORD = 'gstr9new/Common/TOTAL_RECORD';

// Common file operations
export const FILE_UPLOAD_STATUS = 'gstr9new/Common/FILE_UPLOAD_STATUS';
export const FILE_VALIDATION_ERROR = 'gstr9new/Common/FILE_VALIDATION_ERROR';

// Common API status
export const API_SUCCESS = 'gstr9new/Common/API_SUCCESS';
export const API_ERROR = 'gstr9new/Common/API_ERROR';

export const SET_ENTITY_LIST = 'gstr9new/Common/SET_ENTITY_LIST';
export const SET_SELECTED_ENTITY = 'gstr9new/Common/SET_SELECTED_ENTITY';
export const SET_SELECTED_GSTIN = 'gstr9new/Common/SET_SELECTED_GSTIN';
export const SET_SELECTED_RETURN_PERIOD = 'gstr9new/Common/SET_SELECTED_RETURN_PERIOD';
